import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { InformationCircleIcon, TrashIcon } from '@heroicons/react/24/outline'
import { PencilIcon } from '@heroicons/react/24/solid'
import { Input, Textarea } from '@/components/ui'
import { SingleLineAddressOnListing } from '@/components/Address'
import { formatDate } from '@/utils/formatters'
import { deleteActivity, setActivityInEdition } from './activitiesSlice'

export default ({item}) => {
  const dispatch = useDispatch()
  const [ showConfirmDialog, setShowConfirmDialog ] = useState(false)

  const handleDelete = (e) => {
    setShowConfirmDialog(true)
  }

  const confirmDelete = () => {
    dispatch(deleteActivity(item))
    setShowConfirmDialog(false)
  }

  const cancelDelete = () => {
    setShowConfirmDialog(false)
  }

  const handleEditClick = () => {
    dispatch(setActivityInEdition(item))
  }

  return (
    <tr>
      <td><Input.Display label="Date" value={formatDate(item?.date_activity || '')} /></td>
      <td>
        <div className='flex flex-wrap space-x-2 items-center p-1 hover:bg-primary-300'>
          <a 
            className='btn btn-square btn-ghost btn-xs p-1 hover:bg-primary-400'
            href={item.bien?.links?.show ? item.bien.links.show : '#'}
            title="Aller sur la fiche du bien"
          >
            <InformationCircleIcon/>
          </a>
          <div className="flex flex-col">
            <SingleLineAddressOnListing data={item?.bien || {}} />
          </div>
        </div>
      </td>
      <td className="w-[50%] min-w-[300px]">
        <Textarea.Display value={item?.details || ''}
          className='flex flex-col items-start'
        />
      </td>
      {/* <td>
        <div className="flex flex-col">
          <Toggle.Display label="Propriétaire" value={item.display_to_proprietaire} />
          <Toggle.Display label="Locataire" value={item.display_to_locataire} />
        </div>
      </td> */}
      <td>
        <div className="flex flex-col">
          <button className="btn btn-sm btn-ghost btn-square p-2 hover:bg-primary-400"
            title="Modifier l'activité" arial-label="Modifier l'activité"
            onClick={handleEditClick}
          >
            <PencilIcon />
          </button>
          <button 
              onClick={handleDelete}
              className="btn btn-sm btn-ghost btn-square p-2 hover:bg-primary-400"
              title={`Supprimer l'activité`} aria-label={`Supprimer l'activité`}
            >
            <TrashIcon/>
          </button>
          {showConfirmDialog && (
            <dialog open className="modal">
              <div className="modal-box">
                <h3 className="font-bold text-lg">Confirmer la suppression</h3>
                <p className="py-4">Êtes-vous sûr de vouloir supprimer cette activité ?</p>
                <p className="py-4 text-center">{ item.titre }</p>
                <div className="modal-action">
                  <button onClick={confirmDelete} className="btn btn-secondary">Supprimer</button>
                  <button onClick={cancelDelete} className="btn btn-outline">Annuler</button>
                </div>
              </div>
            </dialog>
          )}
        </div>
      </td>
    </tr>
  )
}